import { NavBreadcrumbs, NavBreadcrumbsProps } from '@/components/navigation/NavBreadcrumbs';
import { useQuery } from '@tanstack/react-query';
import { ReactNode, useMemo } from 'react';
import { FetchCustomerQuery, SearchCustomerSitesQuery } from '@/lib/api/customer/customer';
import { RoutePath } from '@/lib/routes';
import { Cctv } from 'lucide-react';

export const DeviceTooolbar = (props: {
  // Base
  customerId?: string;
  projectId?: string;
  siteId?: string;

  // Device
  deviceName?: string;
  deviceId: string;

  // Camera
  cameraId?: string;
  cameraName?: string;
  children?: ReactNode;
}) => {
  const { deviceId, customerId, deviceName, cameraId, cameraName } = props;
  const siteId = props.projectId || props.siteId;

  const customerQuery = useQuery({
    ...FetchCustomerQuery({ customerId: customerId ?? '' }),
    enabled: customerId != null,
  });
  const customer = customerQuery.data;
  const sitesQuery = useQuery({
    // DISABLED DUE TO LEGACY REQUEST
    // eslint-disable-next-line custom/no-large-page-size
    ...SearchCustomerSitesQuery({ customerId: customerId ?? '', pageSize: 1000 }),
    enabled: customerId != null,
  });
  const sites = sitesQuery.data?.rows ?? [];

  const siteName = useMemo(() => {
    if (!deviceId || !sites) return;

    const site = sites.find((s: any) => s.id === siteId);
    if (!site) return;

    return site.name || '';
  }, [sites]);

  const items = useMemo(() => {
    const _items: NavBreadcrumbsProps['items'] = [];

    if (customerId) {
      _items.push({
        label: customer?.name || 'Unnamed Customer',
        href: RoutePath.Customer(customerId),
      });
    }

    if (customerId && siteId) {
      _items.push({
        label: siteName || 'Unnamed Site',
        href: RoutePath.CustomerSite(customerId, siteId),
      });
    }

    _items.push({
      label: deviceName || 'Unnamed Device',
      href: RoutePath.DeviceEdit(deviceId),
    });

    if (cameraId) {
      _items.push({
        label: cameraName || 'Unnamed Camera',
        href: RoutePath.DeviceCamera(deviceId, cameraId),
      });
    }

    return _items;
  }, [customer, siteName, siteId, customerId, deviceName, deviceId, cameraId, cameraName]);

  return (
    <div
      className="z-20 flex h-14 items-center justify-start gap-x-4 border-b bg-[#111] px-4"
      data-onboarding={cameraId ? 'camera-header' : undefined}
    >
      {cameraId && (
        <div className="flex items-center"><Cctv className="mr-2 h-6 w-6" />
          <h1 className="text-lg font-semibold text-white">
            Editing {cameraName || 'Unnamed Camera'}
          </h1>
        </div>
      )}
      {props.children}
    </div>
  );
};
